<template>
    <n-list value="products" text="商品" :fields="fields" :items="products" />
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: '名稱',
                    sortable: true,
                },
                {
                    key: 'extras',
                    label: '選項分類',
                    formatter: value => {
                        return `${value.length}項`
                    },
                    sortable: true,
                    class: 'd-none d-sm-table-cell',
                },
                {
                    key: 'price.PICKUP',
                    label: '自取',
                    formatter: value => {
                        return `$${value}`
                    },
                    sortable: true,
                },
                {
                    key: 'price.DELIVERY',
                    label: '外送',
                    formatter: value => {
                        return `$${value}`
                    },
                    sortable: true,
                },
            ]
        }
    },

    created() {
        this.$store.dispatch('bindCollectionByMerchant', { col: 'products', merchantId: localStorage.merchantId })
    },

    computed: {
        ...mapState({
            products: state => state.products,
        })
    }
}
</script>